import siteConfig from '../../site.config.json';

/**
 * Brand identity shared by code, scripts, and Wrangler config.
 * Change it with `pnpm brand:set`, never by hand-editing one place.
 */
export const SITE = {
  name: siteConfig.name,
  domain: siteConfig.domain,
  slug: siteConfig.slug,
  url: `https://${siteConfig.domain}`,
  supportEmail: `support@${siteConfig.domain}`,
} as const;
